module.exports = __webpack_public_path__ + "media/hallBgm.9a4c3c14.mp3";